import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import { db } from './firebase.js'

Vue.config.productionTip = false

const axiosInstance = axios.create({
  baseURL: "http://127.0.0.1:8000/api"
})

if (localStorage.getItem('token') !== undefined) {
  axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
  // axiosInstance.defaults.headers.common['Accept'] = 'application/json'
}

Vue.prototype.$db = db
Vue.prototype.$axios = axiosInstance

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
